import { render } from "./MenuContentItemInputGroupUpDownBoxAndSelectMenu.vue?vue&type=template&id=7a54a172"
import script from "./MenuContentItemInputGroupUpDownBoxAndSelectMenu.vue?vue&type=script&lang=js"
export * from "./MenuContentItemInputGroupUpDownBoxAndSelectMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__